import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminBoxStatus } from '../enums/admin-box-status';

@Injectable({
  providedIn: 'root',
})
export class AdminBoxStatusProviderService {
  private readonly entries = new Map<AdminBoxStatus, string>([
    [AdminBoxStatus.Draft, 'Szkic'],
    [AdminBoxStatus.Private, 'Prywatny'],
    [AdminBoxStatus.Protected, 'Chroniony hasłem'],
    [AdminBoxStatus.Public, 'Publiczny'],
  ]);

  public labelFor(status: AdminBoxStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminBoxStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
